export enum Queries {
  ComponentStatusList = 'ComponentStatusList',
  QueueStatusList = 'QueueStatusList',
  UserList = 'UserList',
}
